import { Controller } from "@hotwired/stimulus"

export default class extends Controller {
  static targets = ["select", "section", "emptyState"]

  connect() {
    this.filter()
  }

  filter() {
    if (!this.hasSelectTarget) return

    const selectedModule = this.normalizedValue(this.selectTarget.value)
    let visibleSections = 0

    this.sectionTargets.forEach((section) => {
      const sectionModule = this.normalizedValue(section.dataset.moduleName)
      const shouldShow = !selectedModule || sectionModule === selectedModule

      section.toggleAttribute("hidden", !shouldShow)
      section.classList.toggle("hidden", !shouldShow)

      if (shouldShow) visibleSections += 1
    })

    if (this.hasEmptyStateTarget) {
      this.emptyStateTarget.toggleAttribute("hidden", visibleSections > 0)
      this.emptyStateTarget.classList.toggle("hidden", visibleSections > 0)
    }
  }

  normalizedValue(value) {
    return (value || "").toString().trim().toLowerCase()
  }
}
